import HowDoWeSearch from "./HowDoWeSearch.vue"

export default function install(Vue) {
  Vue.component(HowDoWeSearch.name, HowDoWeSearch)
}
